
/**
 * Get the start and end dates of the week for a given date.
 * @param {Date} date - The reference date.
 * @returns {Object} An object with 'from' and 'to' Date properties.
 */
const getWeekRange = (date) => {
  const day = date.getDay();
  const daysToMonday = day === 0 ? -6 : 1 - day;
  const weekStart = new Date(date);
  weekStart.setDate(date.getDate() + daysToMonday);
  weekStart.setHours(0, 0, 0, 0);
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekStart.getDate() + 6);
  weekEnd.setHours(23, 59, 59, 999);
  return { from: weekStart, to: weekEnd };
};

/**
 * Get the highest application letter from the diary entries.
 * @param {Array} diaries - The array of diary entries.
 * @returns {Object} An object containing the highest letter and its index.
 */
const getHighestApplicationLetter = (diaries) => {
  let highest = 'A';
  let index = 1;
  for (let i = 0; i < 26; i++) { 
    const letter = String.fromCharCode(65 + i); // A=65, B=66, ...
    const found = diaries.find(d => d.vano === letter);
    if (found) {
      highest = letter;
      index = i + 1;
    } else {
      break;
    }
  }
  return { highest, index };
}

/**
 * Get the highest assessment number from the diary entries.
 * @param {Array} diaries - The array of diary entries.
 * @returns {number} The highest assessment number (1-99).
 */
const getHighestAssessmentNumber = (diaries) => {
  let highest = 0;
  for (let i = 1; i <= 99; i++) {
    const vanoPattern = i.toString().padStart(2, '0'); // "01", "02", ..., "99"
    const found = diaries.find(d => d.vano === vanoPattern);
    if (found) {
      highest = i;
    } else {
      break;
    }
  }
  return highest;
}

export { getWeekRange, getHighestApplicationLetter, getHighestAssessmentNumber };